import React from 'react';
import { Server, ShieldCheck, FileCheck, ScrollText } from 'lucide-react';

/**
 * InfrastructureTrust — Phase 99A light direction.
 *
 * Discreet platform-infrastructure strip rendered at the bottom of every
 * public page. Uses panel tokens so it sits between the page content and the
 * light footer without breaking the warm-paper rhythm.
 */
export const InfrastructureTrust = () => (
  <section
    className="py-10"
    style={{ background: 'var(--gpc-panel)', borderTop: '1px solid var(--gpc-line-soft)', borderBottom: '1px solid var(--gpc-line-soft)' }}
    data-testid="infrastructure-trust-section"
  >
    <div className="max-w-5xl mx-auto px-6 lg:px-8">
      <p
        style={{
          fontFamily: 'Space Grotesk, system-ui, sans-serif',
          fontSize: '11px',
          textTransform: 'uppercase',
          letterSpacing: '0.2em',
          color: 'var(--gpc-ink-soft)',
          textAlign: 'center',
          marginBottom: '24px',
        }}
      >
        Platform Infrastructure
      </p>

      <p
        style={{
          fontFamily: 'Inter, system-ui, sans-serif',
          fontSize: '14px',
          color: 'var(--gpc-ink-soft)',
          textAlign: 'center',
          lineHeight: 1.6,
          maxWidth: '46rem',
          margin: '0 auto 28px',
        }}
      >
        Private document storage on Amazon Web Services (AWS) S3, supported by controlled access, audit logging, and document-level protections.
      </p>

      <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3">
        {[
          { icon: Server, label: 'AWS document storage' },
          { icon: ShieldCheck, label: 'Role-Based Access Controls' },
          { icon: FileCheck, label: 'Private Document Storage' },
          { icon: ScrollText, label: 'Audit Logging' },
        ].map((item, i) => (
          <div key={i} className="flex items-center gap-2">
            <item.icon className="w-3.5 h-3.5" style={{ color: 'var(--gpc-gold)' }} />
            <span style={{ fontFamily: 'Inter, system-ui, sans-serif', fontSize: '12px', color: 'var(--gpc-ink-soft)' }}>
              {item.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default InfrastructureTrust;
